import { Box, Typography } from '@mui/material'
import { FC, useEffect } from 'react'
import { useScreenSize } from '../../../../hooks/useScreenSize'
import { Achievement } from '../../../RewardService/types'

interface RewardProps {
    reward?: Achievement
    animated?: boolean
}

export const ClaimedReward: FC<RewardProps> = ({ reward, animated }) => {
    useEffect(() => {
        if (reward && animated) {
            document.getElementById(`reward-${reward.challengeId}`)?.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
                inline: 'center',
            })
        }
    }, [animated, reward])

    const { isMobile } = useScreenSize()
    return (
        <Box
            id={`reward-${reward?.challengeId}`}
            sx={{
                '@keyframes appear': {
                    '0%': { opacity: 0, transform: 'scale(0)' },
                    '70%': { opacity: 1, transform: 'scale(1.1)' },
                    '100%': { opacity: 1, transform: 'scale(1)' },
                },
                aspectRatio: '1/1',
                gridArea: 'icon',
                border: '2px solid',
                position: 'relative',
                borderColor: 'common.white',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                overflow: 'hidden',
                '*': { animation: animated ? 'appear 0.75s ease-in-out forwards' : 'none' },
            }}
        >
            <Box
                sx={{
                    zIndex: 100,
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    bottom: 0,
                    right: 0,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                {reward && reward.counter > 1 && (
                    <Typography
                        sx={{ fontVariantNumeric: 'tabular-nums', filter: 'drop-shadow(1px 2px 2px black)' }}
                        variant={isMobile ? 'h5' : 'h2'}
                    >
                        {reward.counter}
                    </Typography>
                )}
            </Box>

            {animated && (
                <Box
                    sx={{
                        zIndex: 1,
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        bottom: 0,
                        right: 0,
                        backgroundImage: `url(/assets/animations/rewards/rays.svg)`,
                        backgroundSize: 'cover',
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'center',
                        animation: 'rotate 10s linear infinite',

                        '@keyframes rotate': {
                            '0%': { transform: 'rotate(0deg)' },
                            '100%': { transform: 'rotate(180deg)' },
                            // '100%': { transform: 'rotate(180deg) scale(0)' },
                        },
                    }}
                />
            )}

            {reward ? (
                <Box
                    sx={{
                        borderRadius: 0,
                        width: '100%',
                        height: '100%',
                        backgroundImage: `url(${reward.assetUrl})`,
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'center',
                        backgroundSize: '90%',
                        filter: 'drop-shadow(1px 2px 2px black)',
                        zIndex: 2,
                        position: 'relative',
                    }}
                />
            ) : (
                <Typography variant={isMobile ? 'body2' : 'h6'} textTransform="uppercase" textAlign="center">
                    No achievements earned yet
                </Typography>
            )}
        </Box>
    )
}
